import React from "react";
import ReactDOM from "react-dom";
import classes from "./error_modal.module.css";
import util from "../../../styles/utilities.module.css";

import ActionButton from "../ActionButton/ActionButton";
const ErrorModal = ({ isOpen, onClose, titleText, bodyText }) => {
  if (!isOpen) {
    return null;
  }

  // Split bodyText by line breaks and map each line to a <div> element
  const formattedBodyText = bodyText.split('\n').map((line, index) => (
    line.trim() === '' ? <div key={index} style={{ height: '1em' }} /> : <div key={index}>{line}</div>
  ));

  return ReactDOM.createPortal(
    <div className={`${util.modalOverlay} ${classes["modal-overlay"]}`}>
      <div className={`${util.modalSurface} ${classes.modal}`}>
        <h1 className={classes.title}>{titleText}</h1>
        <h4 className={classes.body}>
          {formattedBodyText} 
        </h4>
        <ActionButton text="Close" handleOnClick={onClose} variant="ghost" />
      </div>
    </div>,
    document.body
  );
};

export default ErrorModal;
